import { commonGetData, commonGetFile, commonPatchData, commonPostData, commonPostDataWithForm } from "./common";

export async function downloadFile(res: any, fileName: string) {
    const href = window.URL.createObjectURL(res);

    // Create an anchor element for downloading.
    const a = document.createElement('a');
    a.href = href;
    a.download = fileName; // Set the desired filename for the download.

    // Trigger a click event on the anchor element to initiate the download.
    a.click();

    // Clean up the URL and anchor element.
    window.URL.revokeObjectURL(href);
}

const getHeaders = async () => {
    const h: any = {};
    return h;
}

export async function getData(url = "", data: any = {}, withCredential = true) {
    return await commonGetData(withCredential, await getHeaders(), url, data);
}


export async function getFile(url = "", data: any = {}, withCredential = true) {
    return await commonGetFile(withCredential, await getHeaders(), url, data);
}


export async function postData(url = "", data: any = {}, withCredential = true) {
    return await commonPostData(withCredential, await getHeaders(), url, data);
}


export async function postDataWithForm(url = "", data: any = {}, withCredential = true) {
    return await commonPostDataWithForm(withCredential, await getHeaders(), url, data);
}

export async function patchData(url = "", data = {}, withCredential = true) {
    return await commonPatchData(withCredential, await getHeaders(), url, data);
}